import { Controller, UseFormReturn } from "react-hook-form";
import { Combobox, TComboOption } from "@/modern/components/ui/combobox";
import { Label } from "@/modern/components/ui/label";
import { checkGrantOrder } from "@/modern/utils";
import { FileFormData } from "../hooks/useFileDetailForm";

interface FilePermissionsSectionProps {
  form: UseFormReturn<FileFormData>;
  swivuAppGrants: TComboOption[];
  canEditFile: boolean;
}

/**
 * File permissions section (Can Edit / Can View dropdowns)
 */
export const FilePermissionsSection = ({ form, swivuAppGrants, canEditFile }: FilePermissionsSectionProps) => (
  <section className="space-y-4">
    <div className="space-y-2">
      <Label htmlFor="canEdit" className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        Can edit
      </Label>
      <Controller
        name="canEdit"
        control={form.control}
        render={({ field }) => (
          <Combobox
            value={field.value ?? ""}
            options={swivuAppGrants}
            placeholder="Select who can edit"
            emptyValue=""
            disabled={!canEditFile}
            onValueChange={(value) => field.onChange(value ?? "")}
            onBeforeSelect={({ value }) => {
              return checkGrantOrder({ canEdit: value as number, canView: form.getValues("canView") as number, form });
            }}
          />
        )}
      />
    </div>

    <div className="space-y-2">
      <Label htmlFor="canView" className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        Can view
      </Label>
      <Controller
        name="canView"
        control={form.control}
        render={({ field }) => (
          <Combobox
            value={field.value ?? ""}
            options={swivuAppGrants}
            placeholder="Select who can view"
            emptyValue=""
            disabled={!canEditFile}
            onValueChange={(value) => field.onChange(value ?? "")}
            onBeforeSelect={({ value }) => {
              return checkGrantOrder({ canEdit: form.getValues("canEdit") as number, canView: value as number });
            }}
          />
        )}
      />
    </div>
  </section>
);
